import React, { ReactElement } from 'react';
import { CopyableText } from 'b2b-apps/shop/common/components/CopyableText';
import { StockCount } from 'b2b-apps/shop/common/components/StockCount';
import { Props } from './';
import './Features.scss';

const Features = ({
  sku,
  manufacturerProductId,
  manufacturerPageUrl,
  onManufacturerPageClick,
  manufacturerUrl,
  manufacturerName,
  manufacturerWarranty,
  ean,
  quantityOrdered,
  stockCount,
  isSpecialOrder,
  soldSince,
  text,
}: Props): ReactElement => (
  <table className="ProductData-Features cds-Table cds-Table--Features">
    <tbody>
      <tr>
        <td>{text.sku}</td>
        <td><CopyableText>{sku}</CopyableText></td>
      </tr>

      {
        manufacturerProductId ? (
          <tr>
            <td>{text.manufacturerProductId}</td>
            <td>
              <CopyableText>{manufacturerProductId}</CopyableText>
            </td>
          </tr>
        ) : null
      }

      <tr className="ProductData-Features--Truncated">
        <td>{text.manufacturerPage}</td>
        <td>
          <a
            className="cds-Link"
            href={manufacturerPageUrl}
            onClick={onManufacturerPageClick}
            rel="noopener noreferrer"
          >
            {manufacturerName}
          </a>
        </td>
      </tr>

      {
        manufacturerUrl ? (
          <tr className="ProductData-Features--Truncated">
            <td>{text.manufacturerLink}</td>
            <td>
              <a
                className="cds-Link"
                href={manufacturerUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {manufacturerName}
              </a>
            </td>
          </tr>
        ) : null
      }

      <tr>
        <td>{text.manufacturerWarranty}</td>
        <td>
          {manufacturerWarranty > 0
            ? text.manufacturerWarrantyMonths
            : text.manufacturerWarrantyMonthsZero
          }
        </td>
      </tr>

      <tr>
        <td>{text.soldSince}</td>
        <td>{soldSince}</td>
      </tr>

      {
        ean ? (
          <tr>
            <td>{text.ean}</td>
            <td><CopyableText>{ean}</CopyableText></td>
          </tr>
        ) : null
      }

      <tr>
        <td>{text.stock}</td>
        <td>
          <StockCount
            isSpecialOrder={isSpecialOrder}
            quantityOrdered={quantityOrdered}
            stockCount={stockCount}
            isFullSize={true}
          />
        </td>
      </tr>
    </tbody>
  </table>
);

export { Features };
